/* eslint-disable react/jsx-key */
// import { QuestionCircleOutlined } from '@ant-design/icons';
import React from 'react';
// import { Card, Row, Col } from 'antd';

import styles from './FormCard.module.scss';


export const FormCard = ({ headerAddition, title, icon, children, action, isDisclaimer, id }) => (


  <div className={ styles.card } id={ id }>
    <div className={ styles.cardHeaderActionDiv }>
      {action}

    </div>
    <div className={ styles.row } style={ isDisclaimer === true ? { backgroundColor: '#FEF3F2' } : {} }>
      <span className={ styles.title }>
        {icon}
        <h2 style={ isDisclaimer === true ? { color: '#F04438' } : {} }>
          {title}
        </h2>
      </span>

      {headerAddition}
    </div>
    <div>
      {children}
    </div>
  </div>
);

